<template>
  <div class="relative">
    <UIIconButton
      icon="EllipsisVerticalIcon"
      @click="isOpen = !isOpen"
    >
      <UIActions
        v-if="isOpen"
        :id="'dialog-actions-' + dialog.id"
        v-click-outside="() => isOpen = false"
        :actions="getActions()"
      />
    </UIIconButton>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import UIIconButton from '@/components/ui/UIIconButton.vue';
import UIActions from '@/components/ui/UIActions.vue';
import {deleteAiDialog} from "@gpx-spa/queries";



const props = defineProps({
  dialog: {
    type: Object,
    required: true
  }
});


const emit = defineEmits(['actionCompleted']);

const store = useStore();
const isOpen = ref(false);

const accountId = store.getters['auth/accountId'];
const deleteDialogAPI = deleteAiDialog(accountId);

function getActions() {
  const editDialog = {
    icon: 'PencilSquareIcon',
    label: 'Edit',
    action: {
      mode: 'fn',
      fn: () => {
        store.dispatch('modal/open', {
          name: 'DialogEditModal',
          params: {
            actionLabel: 'Edit',
            dialog: props.dialog,
            onSuccess: () => {
              emit('actionCompleted');
              isOpen.value = false;
            }
          },

        });
      }
    }
  };

  const deleteDialog = {
    icon: 'TrashIcon',
    label: 'Delete',
    action: {
      mode: 'fn',
      fn: () => {
        store.dispatch('modal/open', {
          name: 'CommonConfirmationModal',
          params: {
            actionLabel: 'Delete',
            title: 'Delete Dialog',
            body: 'Are you sure you want to delete this dialog?',
            onOk: () => {
              return new Promise((resolve, reject) => {
                deleteDialogAPI.mutate(
                  props.dialog.id,
                  {
                    onSuccess: () => {
                      emit('actionCompleted');
                      isOpen.value = false;

                      resolve()
                    },
                    onError: (error) => {
                      console.error('Failed to delete dialog:', error);
                      reject(error)
                    }
                  }
                );
              })
            },
            successMessage: 'Dialog deleted successfully',
            errorMessage: 'Failed to delete dialog'
          }
        });
      }
    }
  };

  return [editDialog, deleteDialog];
}
</script>
